import type { LucideIcon } from "lucide-react";

import { cn } from "@/lib/utils";

/** Ohanglar — hammasi `src/index.css` dagi tokenlardan. */
const TONES = {
  neutral: "bg-muted text-muted-foreground",
  primary: "bg-primary/10 text-primary",
  success: "bg-success-soft text-success",
  warning: "bg-warning-soft text-warning",
  danger: "bg-destructive/10 text-destructive",
  info: "bg-info-soft text-info",
  live: "bg-live-soft text-live",
} as const;

export type StatusTone = keyof typeof TONES;

interface StatusPillProps {
  label: string;
  tone?: StatusTone;
  /** Ikonka MAJBURIY EMAS, lekin tavsiya etiladi. */
  icon?: LucideIcon;
  /**
   * Yorliq oldida tepib turgan nuqta: holat HOZIR kuzatilayotganini bildiradi
   * (tizim holati, avtomatik yangilanish). Nuqta rangi — pill matnining rangi
   * (`bg-current`), ya'ni ohang uchun alohida xarita kerak emas.
   */
  live?: boolean;
  className?: string;
}

/**
 * Holat nishoni.
 *
 * Har doim MATN bilan keladi va odatda ikonka bilan: holat faqat rang bilan
 * uzatilmaydi. Rang ko'rmaydigan odam ham, kulrang bosma ham holatni o'qiy
 * oladi.
 */
export const StatusPill = ({
  label,
  tone = "neutral",
  icon: Icon,
  live,
  className,
}: StatusPillProps) => (
  <span
    className={cn(
      "inline-flex w-fit items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium whitespace-nowrap",
      TONES[tone],
      className,
    )}
  >
    {live && <LiveDot />}
    {Icon && <Icon className="size-3.5 shrink-0" aria-hidden />}
    {label}
  </span>
);

/**
 * Tepib turgan nuqta. `animate-ping` CSS animatsiyasi: "harakatni
 * kamaytirish" yoqilganda `index.css` dagi global qoida uni bir zumda
 * tugatadi va nuqta shunchaki to'q doira bo'lib qoladi.
 */
export const LiveDot = ({ className }: { className?: string }) => (
  <span aria-hidden data-slot="live-dot" className={cn("relative flex size-2 shrink-0", className)}>
    <span className="absolute inline-flex size-full animate-ping rounded-full bg-current opacity-60" />
    <span className="relative inline-flex size-2 rounded-full bg-current" />
  </span>
);
